// extracted by mini-css-extract-plugin
module.exports = {"mock-freshchat-container":"index_mock-freshchat-container_2phDL"};